export default function Hero() {
  return (
    <section id="start" className="relative flex min-h-[560px] w-full items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20editorial%20newsroom%20background%20with%20warm%20amber%20and%20cream%20tones%2C%20abstract%20timeline%20path%20and%20light%20streaks%2C%20soft%20bokeh%20bokeh%20particles%2C%20minimal%20modern%20magazine%20style%2C%20stylized%20not%20photorealistic%2C%20high%20contrast%20dark%20overlay%20friendly%2C%20cinematic%20composition&width=1800&height=900&seq=hero-haijiao-01&orientation=landscape"
        alt="海角吃瓜事件追踪的新闻编辑部氛围背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-100 backdrop-blur">
          <i className="ri-fire-line text-accent-400"></i>
          持续追踪 · 全网事件时间线 · 真相分层梳理
        </span>
        <h1 className="heading-font mx-auto mt-6 max-w-4xl text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-tight">
          海角吃瓜 · 事件始末一次看全
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          海角吃瓜事件始末、现场细节与后续进展全收录。以清晰时间线、客观信息分级与持续更新为原则，
          帮你快速理清来龙去脉、分辨各方说法，一次看全不迷路。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a href="#timeline" className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400">
            查看事件时间线
          </a>
          <a href="#topics" className="whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20">
            浏览热点追踪
          </a>
        </div>
        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-3 gap-3 md:gap-6">
          {[
            ['3.2万+', '已追踪事件'],
            ['1200+', '核实节点'],
            ['24h', '持续响应更新'],
          ].map(([num, label]) => (
            <div key={label} className="rounded-lg bg-background-50/10 px-3 py-4 text-center backdrop-blur">
              <div className="heading-font text-2xl font-black text-background-50 md:text-3xl">{num}</div>
              <div className="mt-1 text-xs text-background-100/80">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}